export const priorityColorsDetector = (priorityTextLowerCased) => {
  const priorityColorsDefinition = {
    low: 'blue',
    medium: 'orange',
    high: 'red',
  };

  return priorityColorsDefinition[priorityTextLowerCased];
};
